export const isObjectEmpty = (obj: { [key: string]: any }) => {
  let counter = 0;
  for (const property in obj) {
    if (
      obj[property]?.length > 0 ||
      typeof obj[property] === 'number' ||
      typeof obj[property] === 'boolean'
    )
      counter++;
  }

  return counter === 0;
};
